import React, { useEffect, useRef } from "react"
import * as bodyScrollLock from "body-scroll-lock"
import sizeChartImage from "@images/sizing-chart.jpeg"

const ClassicHarnessSizePopup = ({ toggle, isOpen }) => {
  const popupRef = useRef()
  useEffect(() => {
    if (popupRef.current) {
      if (isOpen) {
        bodyScrollLock.disableBodyScroll(popupRef.current)
      } else {
        bodyScrollLock.enableBodyScroll(popupRef.current)
      }
    }
  }, [isOpen])
  
  return (
    <div
      ref={popupRef}
      className={`fixed top-0 right-0 bottom-0 left-0 flex px-2 sm:px-8 z-[53] items-center justify-center ${
        isOpen ? `` : `hidden`
      }`}
      role="dialog"
      aria-labelledby="productDetailsPopupHeading"
    >
      <div
        className="absolute top-0 left-0 z-10 w-full h-full bg-black opacity-25"
        onClick={toggle}
      ></div>
      <div className="relative z-20 max-w-full sm:max-w-lg m-auto bg-white max-h-[calc(100vh-2rem)] overflow-y-auto">
        <div className="h-full overflow-x-hidden overflow-y-auto scrolling-touch">
          <button
            className="absolute top-0 left-0 p-2 mt-2 ml-2 transition transition-colors ease-in-out hover:bg-near-black"
            onClick={toggle}
          >
            <span className="hidden">Close</span>
            <svg
              width="13"
              height="13"
              viewBox="0 0 13 13"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.798 11.797L1 1M1 11.797L11.797 1"
                stroke="#000"
                strokeLinecap="round"
              />
            </svg>
          </button>
          <div className="p-8 md:pt-12 md:px-8 md:pt-8 md:pb-10">
            <p className="font-medium text-3xl text-center pb-5" id="productDetailsPopupHeading">Classic Harness Sizing Guide</p>
            <img src={sizeChartImage} alt="Sizing chart for dog harnesses, showing measurements for X-Small, Small, Medium, and Large sizes." className="object-cover w-full h-full" />
            <footer className="text-center mt-7">
              <button
                onClick={toggle}
                className="btn btn-primary hover:text-near-black w-full"
              >
                Back to Shopping
              </button>
            </footer>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ClassicHarnessSizePopup